module.exports = new __parcel__URL__("personal_space.c63f5733.png").toString();